<div class="form-values">
  <div class="close">
    <voxel-icon (click)="back()">fechar</voxel-icon>
  </div>
  <h1 class="title" [innerHtml]="copyService.copies.documents_sends.title"></h1>
  <h3
    class="subtitle"
    [innerHtml]="copyService.copies.documents_sends.subTitle"
  ></h3>
  <div class="box-desc">
    <div>
      <h3>{{copyService.copies.documents_sends.empleados_title}}</h3>
      <ul class="mt-3">
        <vcl-list>
          <li
            *ngFor="let emp of copyService.copies.documents_sends.empleados"
            vclListSimple
          >
            <span id="iconCheck" class="icon icon-itaufonts_check"> </span>
            <vcl-list-text class="list">
              {{ emp }}
            </vcl-list-text>
          </li>
        </vcl-list>
      </ul>
    </div>
  </div>
  <div class="box-desc">
    <div>
      <h3>{{copyService.copies.documents_sends.independientes_title}}</h3>
      <ul class="mt-3">
        <vcl-list>
          <li
            *ngFor="
              let inde of copyService.copies.documents_sends.independientes
            "
            vclListSimple
          >
            <span id="iconCheck" class="icon icon-itaufonts_check"> </span>
            <vcl-list-text class="list">
              {{ inde }}
            </vcl-list-text>
          </li>
        </vcl-list>
      </ul>
    </div>
  </div>
  <div class="box-desc">
    <div>
      <h3>{{copyService.copies.documents_sends.pensionados_title}}</h3>
      <ul class="mt-3">
        <vcl-list>
          <li
            *ngFor="let pen of copyService.copies.documents_sends.pensionados"
            vclListSimple
          >
            <span id="iconCheck" class="icon icon-itaufonts_check"> </span>
            <vcl-list-text class="list">
              {{ pen }}
            </vcl-list-text>
          </li>
        </vcl-list>
      </ul>
    </div>
  </div>
  <div class="box-desc">
    <div>
      <h3>{{copyService.copies.documents_sends.rentistaCapital_title}}</h3>
      <ul class="mt-3">
        <vcl-list>
          <li
            *ngFor="
              let rencap of copyService.copies.documents_sends.rentistaCapital
            "
            vclListSimple
          >
            <span id="iconCheck" class="icon icon-itaufonts_check"> </span>
            <vcl-list-text class="list">
              {{ rencap }}
            </vcl-list-text>
          </li>
        </vcl-list>
      </ul>
    </div>
  </div>
  <vcl-button
  class="button"
  id="button-principal"
  label="{{copyService.copies.documents_sends.Button}}"
  (click)="back()"
  ></vcl-button>
</div>
